<template>
  <div class="audience-filter-category">
    <div class="category">{{ categoryTitle }}</div>
    <div class="items">
      <p-check
        class="p-icon p-curve p-smooth is-blue"
        v-for="item in checkItems"
        :key="item.id"
        v-model="item.isActive"
        @click.native="toggle(item.id)"
      >
        <i class="icon material-icons" slot="extra">&#xE876;</i>
        {{ displayName(item) }}
      </p-check>
    </div>
  </div>
</template>

<script>
import { humanize } from "utils/string";
import { map, some, assignIn } from "lodash";
import { mapState } from "vuex";

export default {
  name: "AudienceFilterCategory",
  props: {
    type: {
      type: String,
      required: true
    },
    category: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState("audience", ["filters"]),

    checkItems() {
      return map(this.items, item =>
        assignIn({}, item, { isActive: this.isActive(item.id) })
      );
    },

    categoryTitle() {
      if (this.type === "segments") {
        return this.$t(`types.${this.type}.subcategories.${this.category}`);
      }

      return this.$t(`types.${this.type}.categories.${this.category}`);
    }
  },
  methods: {
    humanize(value) {
      return humanize(value);
    },

    toggle(id) {
      const isActive = this.isActive(id);
      const type = this.type;
      const item = { type, id };

      if (isActive) {
        this.$store.commit("audience/removeFilterItem", item);
      } else {
        this.$store.commit("audience/addFilterItem", item);
      }
    },

    isActive(id) {
      return some(
        this.filters,
        item => item.type === this.type && item.id === id
      );
    },

    displayName(item) {
      const { keypath } = item;

      if (keypath) {
        return this.$t(keypath);
      }

      return item.display_name;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~scss/utilities/initial-variables.scss";
@import "~scss/utilities/derived-variables.scss";

.audience-filter-category {
  margin-bottom: 2rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.category {
  color: rgba($black, 0.87);
  font-size: $size-small;
  font-weight: $weight-medium;
  letter-spacing: 2.5px;
  text-transform: uppercase;

  + .items {
    margin-top: 1.25rem;
  }
}

.pretty {
  display: block;
  margin-bottom: 0.75rem;
  text-transform: lowercase;
}
</style>

